import Users from "@pages/admin/Users";
import Groups from "@pages/admin/Groups";
import Communities from "@pages/admin/Communities";
import Logout from "../pages/admin/Logout";
import Reports from "@pages/admin/Reports";
import Settings from "@pages/admin/Settings";
import { Navigate } from 'react-router-dom';

const addCommunityAdminRoute = (route) => {
  return "/community-admin" + route;
};
const communityAdminRoutes = [
  { path: addCommunityAdminRoute("/"), element: <Navigate to={addCommunityAdminRoute('/users')} replace /> },
  { path: addCommunityAdminRoute("/users"), element: <Users /> },
  { path: addCommunityAdminRoute("/groups"), element: <Groups /> },
  { path: addCommunityAdminRoute("/communities"), element: <Communities /> },
  { path: addCommunityAdminRoute("/reports"), element: <Reports /> },
  { path: addCommunityAdminRoute("/settings"), element: <Settings /> },
  { path: addCommunityAdminRoute("/logout"), element: <Logout /> },
];

export default communityAdminRoutes;
